import React from 'react';
import { Container } from 'react-bootstrap';
import FacilitatorNavbar from '../components/FacilitatorNavbar';
import FacilitatorProgramView from '../components/FacilitatorProgramView';
import '../styles/brand.css';

const FacilitatorProgramManagement = () => {
  return (
    <>
      <FacilitatorNavbar />

      {/* Hero Section */}
      <section className="hero-section">
        <Container>
          <div className="row">
            <div className="col-lg-8">
              <h1 className="mb-3">My Programs</h1>
              <p className="mission-text mb-4">
                Manage your assigned programs and create learning content
              </p>
              <p className="mb-0">
                View your assigned programs, create modules, manage cohorts, and track learner progress within your educational programs.
              </p>
            </div>
          </div>
        </Container>
      </section>

      <Container className="mt-4">
        <FacilitatorProgramView />
      </Container>
    </>
  );
};

export default FacilitatorProgramManagement;